import React from 'react';
import '../styles/history.css'; // Ensure this CSS file is created and linked properly

function History() {
    return (
        <div className="history">
            {/* Which Came First: Student or Crazie? */}
            <div className="box">
                <p className="title">Which Came First: Student or Crazie?</p>
                <p className="subtitle">The Student Animals and Bunch of Guys</p>
                <div className="content">
                    <p>To properly tell the story of Krzyzewskiville, one must first understand the advent of rabid fanaticism at Duke basketball games. 
                        Students in Cameron have always been known for Crazieness, 
                        but one group in particular turned things up a notch.
                    </p>
                    <blockquote>
                        <p>We're just following tradition, say the Animals. That they are. 
                            A few years ago, whenever he saw time in Cameron, corpulent Virginia forward Dan Merrifield was greeted 
                            with cries of "Orca!" In 1979, Tar Heel forward Mike O'Koren's acne earned him a 
                            banner proclaiming him OXY-1000 POSTER CHILD, on the off chance he wasn't already 
                            sufficiently self-conscious. Jim (Bozo) O'Brien, a Maryland forward in the early 
                            '70s, was easy to spot because of his thinning, curly red hair. During warmups at 
                            Duke one winter's night, a Student Animal sporting a red rubber nose, floppy shoes 
                            and a red Bozo the Clown wig joined the layup line behind O'Brien. Dueling Bozos.
                            The crowd went wild.
                        </p>
                    </blockquote>
                    <p>
                        It started as early as the 1960s, 
                        when the university approved campus status for a selective living group 
                        known as the <a href="http://www.dukechronicle.com/article/2012/07/bogged-down-crazie" target="_blank" rel="noopener noreferrer">
                        Bunch of Guys</a>. The now-infamous organization was the only 
                        all-male SLG at the time and was intended to function as an alternative to 
                        the Greek life present on campus. Free from the restrictions surrounding 
                        traditional fraternity recruitment, the Bunch of Guys attracted a subset
                        of the student population that quickly became notorious for its sharp wit, 
                        its disregard for authority, and its love of Duke basketball.
                    </p>
                    <blockquote>
                        <p>
                        “[The Bunch of Guys] were the entertainers of the entertainment,” 
                        Krzyzewski wrote in an email. “They were in the middle of everything. 
                        I know they created a lot of angst and were a cause of concern at times,
                        but overall, they were great.”</p>
                    </blockquote>
                    <p>
                        Over the years, as the student section at Duke evolved from the Student
                         Animals into the Cameron Crazies of today, the Boggers 
                         (Bunch Of Guy -ers) marched in the vanguard, constantly toeing the 
                         line between barely acceptable and downright crude. After a particularly 
                         controversial event involving Maryland player Herman Veal in 1984, 
                         Duke president Terry Sanford - affectionately known as "Uncle Terry" by 
                         students - wrote the now-famous <a href="https://www.flickr.com/photos/dukeyearlook/12039383323/" target="_blank" rel="noopener noreferrer"> Avuncular Letter</a> that asked students to 
                         clean up their act. Wit and sarcasm prevailed, and at the following contest 
                         against Carolina, students donned tin foil halos and brandished signs reading 
                         "WELCOME, FELLOW SCHOLARS" and "A HEARTY WELCOME TO DEAN SMITH."
                    </p>
                    <p>
                      After their on-campus behavior took a turn for the worse in the late 
                      eighties, the Bunch of Guys was eventually disbanded in 1992, leaving
                      behind a legacy of wit and dedication alongside crude and
                      questionable-at-best behavior. Many students would soon follow in their 
                      footsteps at basketball games, though the level of cruditas has never 
                      returned to its former peak.
                    </p>
                </div>
            </div>

            {/* 1986: Humble Beginnings */}
            <div className="box">
                <p className="title">1986: Humble Beginnings</p>
                <p className="subtitle">One Dukie's quest to be first spawned a tradition</p>
                <div className="content">
                    <p>
                        During the Bunch of Guys' heyday, sleeping out for games was not unheard of. 
                        Most sleep-outs lasted for a night or two before the game. 
                        The Chronicle notes that three students slept on the sidewalk for entry into the 1984
                        Carolina game, with a few more sleeping out the following year.
                    </p>
                    <p>
                        Tradition traces the origins of the Krzyzewskiville phenomenon to a cold 1986 evening and a game of quarters.
                    </p>
                    <p>
                        Kimberly Reed, a student in the Mirecourt selective living group on campus, 
                        rallied a group of sixteen tipsy students to pitch a tent a week before game day 
                        in order to be first in line for the impending clash between Duke and UNC. While Reed 
                        and her cohorts were not the first to camp out before a game, they were most certainly 
                        first in line for that famous 1986 game - the catalyst that begat the first Krzyzewskiville.
                    </p>
                    <blockquote> 
                        <p>
                        "It was common for people to line up hours before a game," said Kimberly Reed, Trinity 
                        '86, who was one of the first tenters. "We were playing quarters one night at Mirecourt 
                        and joking about how early we were going to line up for the '86 
                        [University of North Carolina at Chapel Hill] game. Finally, someone said, 
                        'Why don't we just pitch a tent?' After a few rounds of quarters, it began to sound 
                        like a good idea."
                        </p>
                    </blockquote>
                </div>
            </div>

            {/* Enter the Line Monitors */}
            <div className="box">
                <p className="title">Enter the Line Monitors</p>
                <p className="subtitle">It catches on</p>
                <div className="content">
                    <p>By the time doors had opened for the 1986 Duke/UNC game, a
                        round 75 tents had been constructed on the grassy lawn in front of Cameron Indoor Stadium. 
                        Concerns for student safety and integrity of the ticketing process arose after 
                        the line violently compacted before tip-off, resulting in multiple injuries and accusations
                         of line-cutting.
                    </p>
                    <p>
                        The Associated Students of Duke University (ASDU) - the predecessor of the Duke Student 
                        Government we know and love today - instituted student line monitoring for the 1984 season 
                        in response to the antics of the Bunch of Guys. Their job? Simple: if a line formed before 
                        a game, keep it under control within reason. As a part of ASDU's Building, Grounds, 
                        and Athletic Affairs Committee, the chairman of the committee ran the show.
                    </p>
                    <p>
                        After the issues surrounding the 1986 tilt against Carolina, however, 
                        line monitoring responsibility was formally separated from the student government, 
                        though the Line Monitors retain close ties to DSG today.
                    </p>
                    <p>
                        Krzyzewskiville has grown thanks to both outside influence and student culture. 
                        The position of Head Line Monitor was created in 1989, and each successive group of Line Monitors 
                        has tweaked and revised the tenting policy to close loopholes and better suit the campus climate.
                    </p>
                    <p>
                        Krzyzewskiville is, as Coach K would put it, alive. It has endured and adapted for over
                        forty years.
                    </p>
                </div>
            </div>

            {/* The Cameron Crazies' Greatest Hits */}
            <div className="box">
                <p className="title">The Cameron Crazies' Greatest Hits</p>
                <p className="subtitle">Building the reputation</p>
                <div className="content">
                    <p>While K-Ville has grown and changed, the atmosphere inside Cameron still 
                        hearkens back to an era gone by. Student seating is so close to the floor 
                        that conversations with players are mere happenstance.
                         Crazies know game officials by name, and vice versa.
                    </p>
                    <p>
                        In close games against North Carolina and other top ten opponents, 
                        decibel levels inside Cameron have approached 130 dB - 
                        approximate to standing next to an aircraft taking off on a runway.
                        The bleachers rattle, the floor shakes, and the rafters and foundations 
                        quake with increasing fervor each time a three-pointer is made or dunk slammed.
                    </p>
                    <p>
                        Aside from pure volume, the Crazies have made a name for themselves as one of 
                        the wittiest fan bases in the country, inventing many chants and practices that 
                        have become commonplace at collegiate sporting events. One such example occurred
                         during a 1979 contest against the Tar Heels. UNC, notorious at the time for 
                         running a stall offense, took only one shot in the entire first half - 
                         which failed to draw iron. Rich Yonakor, the poor Tar Heel who took the shot, 
                         was serenaded with the now-ubiquitous "Air Ball!" chant for the first time.
                    </p>
                </div>
            </div>

            {/* Krzyzewskiville Today */}
            <div className="box">
                <p className="title">Krzyzewskiville Today</p>
                <p className="subtitle">Still Crazie after all these years</p>
                <div className="content">
                    <p>Today, Krzyzewskiville has grown to be an integral part of the Duke experience, 
                        bringing together students from all walks of life in a unique way that no other 
                        on-campus organization can duplicate.</p>
                    <p>
                        Krzyzewskiville's population each year stands at 1,560: one hundred and thirty tents.
                        The final thirty of these tents are not guaranteed spots in Cameron on 
                        gameday – their entry is space dependent. A waiting list is usually formed for 
                        tents who were not able to register in time. The most hard-core fans start 
                        tenting during the Black Tenting period, which begins the day before the second 
                        semester commences. The 2012 season saw a record-setting forty-six Black tents 
                        pitch on the first day of the tenting season after criticisms of declining 
                        attendance. In 2019 (the year of Zion Williamson), a new record was set, 
                        with over 130 tents registering to start on the very first day of Black Tenting.
                        In order to decide who could tent, a trivia test was administered, which covered statistics and 
                        personal information about that season’s players, games, and coaching staff. 
                        The 70 groups with the highest scores earned spots in K-Ville as Black Tents. 
                        This method of tie-breaker was again necessary in 2021 (Coach K’s last season) and 2022
                        (Coach Scheyer’s first season).
                    </p>
                    <p>
                        Students come and go. Players come and go. K-Ville’s namesake himself, 
                        Mike Krzyzewski, came and eventually went. What makes Krzyzewskiville so
                         special is its power as a unifying force, acting on both students and alumni 
                         as part of a tradition that stretches back for decades.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default History;
